<template>
  <Content style="paddingTop: 20px;">
    <avue-form-design
    ref="avueformdesign"
    :mode="2"
    @on-mode="handleMode"
    :options="options" />

  </Content>
</template>

<script>
import Content from './Content'
export default {
  props: {
    mData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Content,
    AvueFormDesign: () => import('@/workFlow/formComponent/formDesigner/packages/index.vue')
  },
  data() {
    return {
      options: {}
    }
  },
  watch: {
    options: {
      handler(val) {
        this.$emit('on-mode', 'formModel', val)
      },
      deep: true
    }
  },
  created() {
    const {
      formModel
    } = this.mData
    if (formModel) {
      this.options = {
        ...formModel
      }
    }
  },
  methods: {
    handleMode(val) {
      this.options = val
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
